export type FacilityContact = {
  uuid: string
  isPreferable: boolean
  isShipper: boolean
  isReceiver: boolean
  name: string
  email: string
  phoneNumber?: string
  phoneNumberExtension?: string
  ownerType?: string
  ownerUuid?: string
  tmsLink?: string
}

export function getMainContact(contacts: Array<FacilityContact>) {
  if (!contacts || contacts.length === 0) return

  const preferredContact = contacts.find(
    contact => contact.isPreferable && (contact.phoneNumber || contact.email)
  )

  if (preferredContact) return preferredContact

  return contacts.find(contact => contact.phoneNumber || contact.email)
}
